
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic05 as ObiLogic05Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-05.js';
 
 
 

 
 export const ObiLogic05 = createComponent({
   react: React,
   tagName: 'obi-logic-05',
   elementClass: ObiLogic05Element,
   events: {
     
   }
  });
 
 